import React,{ useState } from 'react';
import Counters from "./common/counter.component";
import Buttoncom from "./common/button.component";

function Counterapp() {
    const [counter, setCounter] = useState({ numbers: [] });

  function incre(index){
    const numbers = [...counter.numbers];
    numbers[index]++
    setCounter({ numbers })
  }

  function decre(index){
    const numbers = [...counter.numbers];
    numbers[index]--
    setCounter({ numbers })
  }

  function reset(index){
    const numbers = [...counter.numbers];
    numbers[index] = 0
    setCounter({ numbers })
  }

  function dlt(index){
    const numbers = [...counter.numbers];
    numbers.splice(index,1)
    setCounter({ numbers })
  }
  
  return (
    <>
      <Buttoncom
        text="ADD"
        variant="success"
        event={() => {
          setCounter({ numbers: [...counter.numbers, 0] });
        }}
        className="mx-5 mt-3"
      />
      <br />
      <h6 className="mx-5 mt-3">Please Click ADD button...</h6>
      <hr />
      {counter.numbers.map((number, index) => {
        return <React.Fragment key = {index}>
          <Counters
            index = { index } 
            number = { counter.numbers[index] } 
            onIncre = { incre }
            onDecre = { decre }
            onReset = { reset }
            onDelete = { dlt }
          />;
        </React.Fragment>
      })}
    </>
  );
}

export default Counterapp;